import { resolveEndpoint } from '../endpointUtils';

export default {
	beneficiaries: {
		uri: '/ibapi/v2/banks/:bankId/accounts/:scopeId/:accountId/beneficiaries/account',
		x_bpi_version: '0.8.0',
		method: 'POST',
		resolve(bankId, scopeId, accountId) {
			return resolveEndpoint(this.uri, { bankId, scopeId, accountId });
		},
	},
	getLcvPayees: {
		uri: '/ibapi/v2/banks/:bankId/accounts/default/beneficiaries?page=:page&benType=:benType&size=:size&search=:search&searchAccountNumber=:accountNumber&searchSortCode=:sortCode&searchPayeeName=:name',
		x_bpi_version: '0.8.0',
		method: 'GET',
		resolve({ page, size, search, benType, accountNumber, sortCode, name }) {
			return resolveEndpoint(this.uri, { page, size, search, benType, accountNumber, sortCode, name });
		},
	},
	addPayee: {
		uri: '/ibapi/v2/banks/:bankId/accounts/default/:accountId/beneficiaries/account',
		x_bpi_version: '0.8.0',
		method: 'POST',
		resolve(bankId, scopeId, accountId) {
			return resolveEndpoint(this.uri, { bankId, scopeId, accountId });
		},
	},
	deletePayee: {
		uri: '/ibapi/v2/banks/:bankId/accounts/default/:accountId/beneficiaries/:beneficiaryId',
		x_bpi_version: '0.8.0',
		method: 'DELETE',
		resolve(bankId, accountId, scopeId, beneficiaryId) {
			return resolveEndpoint(this.uri, { bankId, accountId, scopeId, beneficiaryId });
		},
	},
	addInternationalPayee: {
		uri: '/ibapi/v2/banks/:bankId/accounts/:scopeId/:accountId/beneficiaries/international/account',
		x_bpi_version: '0.8.0',
		method: 'POST',
		resolve(bankId, scopeId, accountId) {
			return resolveEndpoint(this.uri, { bankId, scopeId, accountId });
		},
	},
	getAllBeneficiaries: {
		uri: '/ibapi/v2/banks/:bankId/accounts/:scopeId/beneficiaries',
		x_bpi_version: '0.8.0',
		method: 'GET',
		resolve(bankId, scopeId) {
			return resolveEndpoint(this.uri, { bankId, scopeId });
		},
	},
	getBeneficiaryById: {
		uri: '/ibapi/v2/banks/:bankId/accounts/default/beneficiaries/:beneficiaryId',
		x_bpi_version: '0.8.0',
		method: 'GET',
		resolve(beneficiaryId) {
			return resolveEndpoint(this.uri, { beneficiaryId });
		},
	},
};
